
<style lang="less">
.home_search {
  .noProduct {
    padding: 20px;
    text-align: center;

    & > div {
      text-align: center;
      font-size: 0.32rem;
      margin-top: 10px;
    }
  }
  .search_title {
    background-color: #fff !important;
    & > div {
      padding: 10px;
      background: #fff;
      .van-search__input-wrap {
        border-radius: 0.32rem;
        background-color: rgb(232, 232, 232);
        //   padding: 0.16rem 0.18rem 0.16rem 0.7rem;

        & > input {
          background-color: rgb(232, 232, 232);
          //  font-size: 0.24rem;
          color: rgb(153, 153, 153);
        }

        & > .van-icon .van-icon-clear {
          display: block;
          width: 0.32rem;
          height: 0.32rem;
          color: rgb(153, 153, 153);
          font-size: 0.32rem;
        }
      }
      .van-search__action-text {
        //    font-size: 0.28rem;
        color: rgb(51, 15, 51);
      }
    }

    & > .search_val {
      position: absolute;
      z-index: 1000;
      background-color: #fff;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      font-size: 16px;

      & > ul {
        padding: 10px;

        & > li {
          border-bottom: 1px solid #ccc;
          padding: 5px;
        }
      }
    }
  }
  .search_content {
    padding: 0.22rem 0.24rem;
    font-size: 0.24rem;

    .hot_search,
    .history_search {
      margin-bottom: 0.3rem;
      & > :nth-child(1) {
        color: rgb(153, 153, 153);
        margin-bottom: 0.3rem;
      }
      & > :nth-child(2) {
        ul {
          li {
            float: left;
            margin-right: 0.16rem;
            margin-bottom: 0.16rem;
            div {
              padding: 0.16rem;
              padding: 10px;
              background: rgb(244, 244, 244);
              border-radius: 0.1rem;
              font-size: 0.22rem;
              color: rgb(51, 51, 51);
            }
          }
        }
      }
    }
    .history_search {
      margin-top: 0.24rem;
      i {
        float: right;
        width: 0.26rem;
        height: 0.35rem;
        background: url("../../../static/image/myOrder/ios/delete.png")
          no-repeat center center;
      }
    }
  }
}
.goods-list-wrapper {
  padding: 0 0.3rem;
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      // float: left;
      height: auto;
      border-radius: 10px;
      overflow: hidden;
      width: 3.38rem;
      background: #fff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 10%);
      margin-bottom: 0.16rem;

      &:nth-child(1) {
        .info {
          margin-top: 0.5rem;
          padding: 0 0.24rem 0.32rem;
        }
      }
      .photo {
        height: 3.22rem;
        background: #e5e5e5;
        img {
          height: 100%;
        }
      }

      .info {
        margin-top: 0.32rem;
        padding: 0 0.24rem 0.32rem;
        .title {
          font-size: 0.28rem;
          color: #000;
          line-height: 0.38rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .label {
          margin-top: 0.16rem;
          font-size: 0.22rem;
          color: rgb(138, 138, 147);
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .bot {
          margin-top: 0.24rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0.1rem 0 0 0;
          .price {
            font-size: 0.28rem;
            color: rgb(255, 144, 0);
          }
          .btn-buy {
            border-radius: 50%;
            width: 0.44rem;
            height: 0.44rem;
            background: url("../../../static/image/icon/ios/Join_buy.png")
              no-repeat center center;
          }
        }
      }
    }
  }
}

.nav-back {
  width: 0.44rem;
  height: 0.44rem;
  margin-right: 0.2rem;
  box-sizing: border-box;

  .nav-back-icon {
    display: block;
    width: 100%;
    height: 100%;
    background: url("../../../static/image/icon/ios/back.png") no-repeat center
      center;
  }
}
</style>

<template>
  <div class='home_search'>
    <div class='search_title'>
      <van-search v-model="searchvalue"
                  placeholder="请输入商品关键字"
                  show-action
                  @cancel="onCancel"
                  @keyup="showUl"
                  @keyup.enter="onSearch" />
      <div class='search_val'
           v-if='isShowUl==1'>
        <ul>
          <li v-for='(item,index) in searchTrim'
              :key='item.name'
              @click='getSearchResult(index)'>{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div v-if='hasResult == 0'
         class='search_content'>
      <div class='hot_search'>
        <div class="hot_search_title">
          <span>热门搜索</span>
        </div>
        <div class='hot_search_con'>
          <ul class='clearfix'>
            <li v-for='item in hotSearch'
                @click="clickToGetSval(item.name)"
                :key='item.name'>
              <div>{{item.name}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class='history_search'>
        <div class="hot_search_title clearfix">
          <span>历史搜索</span>
          <!-- 删除历史 -->
          <i @click="onDelHistory"></i>
        </div>
        <div class='hot_search_con'>
          <ul class='clearfix'>
            <!-- v-for循环要有key属性 -->
            <li v-for='item in historySearch'
                @click="clickToGetSval(item.name)"
                :key='item.name'>
              <div>{{item.name}}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 展示搜索结果 -->
    <div v-else>
      <!-- 有搜索结果 -->
      <div v-if='resultAll ==1'>
        <!--商品列表-->
        <div class="
             goods-list-wrapper">
          <ul class="goods-list"
              waterfall-disabled="isWaterfallDisabled"
              waterfall-offset="400
              ">
            <li v-for="(list,index) in resultCard"
                :key="index"
                @click='getProductID(index)'>

              <router-link :to="{name:'detail',params:{id:list.id}}">
                <div class="photo">
                  <img :src="list.src"
                       alt="">
                </div>
                <div class="info">
                  <div class="title">
                    {{list.name}}
                  </div>
                  <div class='label'>
                    {{list.name}}
                  </div>
                  <div class="bot">
                    <span class="price">￥{{list.price}}</span>
                    <div class="btn-buy"></div>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <!-- <div class="loading"
               v-if="loading">
            <van-loading :type="'spinner'"
                         :color="'black'"></van-loading><span>加载中...</span>
          </div> -->
          <!-- 暂时隐藏 -->
          <!-- <div class='no-product'
           v-if="nodata !=0">
        <div>
          <hr />
        </div>
        <div><span>没有更多商品了</span></div>
        <div>
          <hr />
        </div>
      </div> -->
        </div>
      </div>
      <!-- 无搜索结果 -->
      <div v-else
           class='noProduct'>
        <div class=''>暂无商品</div>
        <div>请重新输入商品名称</div>
      </div>
    </div>
  </div>
</template>


<script>
import { Dialog } from 'vant'
import { constants } from 'fs';
import { debug } from 'util';
export default {
  name: 'home_search',
  data () {
    return {
      resultAll: 0,
      hasResult: 0,//展示搜索结果列表
      isShowUl: 0,//展示模糊搜索的列表
      searchvalue: '',//搜索内容
      historySearch: [],
      hotSearch: [],
      searchTrim: [],//模糊查询数组
      resultCard: []//搜索结果列表展示
    }
  },
  mounted () {
    //  //debugger
    this.hotSearch = this.$store.state.hotSearch;
    this.historySearch = this.$store.state.historySearch;
  },
  methods: {
    //展示模糊搜索的列表
    //keydown鼠标
    showUl () {
      if (this.searchvalue.length > 0) {
        this.isShowUl = 1;
        this.searchTrim = this.$store.state.lists.filter(item => {
          console.log(item.name.indexOf(this.searchvalue));
          return item.name.indexOf(this.searchvalue) != -1;
        })
        console.log(this.searchTrim);
      } else {
        //de
        this.searchTrim = [];
      }
    },
    //模糊查询的结果，点击后搜索
    getSearchResult (index) {
      this.searchvalue = this.searchTrim[index].name;
    },
    //直接搜索store的内容
    onSearch () {
      //1、加入历史搜索记录
      if (this.searchvalue.length > 0) {
        //过滤重复添加历史
        this.$store.commit('addHistory', this.searchvalue);
        console.log(this.$store.state.historySearch);

        //2、搜索出结果
        if (this.searchTrim.length > 0) {
          console.log('展示搜索结果');
          console.log(this.searchTrim);
          this.resultCard = this.searchTrim;
          this.hasResult = 1;
          this.resultAll = 1;
        } else {
          this.hasResult = 1;
          this.resultAll = 0;
        }
        this.isShowUl = 0;
      }
    },
    //删除历史
    onDelHistory () {
      Dialog.alert({
        message: '确认删除历史搜索记录吗？'
      }).then(() => {

        //删除历史记录
        this.$store.commit('delHistory');
        this.historySearch = [];
        console.log(this.$store.state.historySearch);
      });
    },
    getProductID (pro_id) {
      ////debugger
      this.$store.commit('change_pro_id', pro_id);
    },
    //点击小标签，进行搜索值的赋值，然后搜索
    clickToGetSval (value) {
      this.searchvalue = value;
    },
    //取消返回
    onCancel () {
      this.$router.push('/home');
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/search/home_search.vue